import React, { useState } from "react"
import {
    Button,
    componentStyles,
    VerticalStack,
} from "@mallardbay/lib-react-components"

import SaveModalList from "~components/pages/wishlist/save-modal-list"
import type {
    UserFieldsFragment,
    WishlistFieldsFragment,
} from "~graphql/generated/graphql"
import Box from "~components/shared/todo-lib-react-components/box"
import Input from "~components/shared/todo-lib-react-components/input"
import Spinner from "~components/shared/todo-lib-react-components/spinner"
import COPY from "~config/copy-constants"
import { useCreateWishlist } from "~utils/use-create-wishlist"

interface WishlistModalProps {
    readonly listingId: string
    readonly wishlists: WishlistFieldsFragment[]
    readonly user: UserFieldsFragment
    readonly isFetching?: boolean
    readonly onClose: () => void
    readonly isCreating: boolean
    readonly setIsCreating: (value: boolean) => void
}

export default function WishlistModalContent({
    listingId,
    wishlists,
    user,
    isFetching,
    onClose,
    isCreating,
    setIsCreating,
}: WishlistModalProps) {
    const styles = useStyles()
    const [listName, setListName] = useState("")

    const { createWishlist, isLoading } = useCreateWishlist({
        onCompleted: () => {
            setListName("")
            setIsCreating(false)
        },
    })

    if (isFetching) {
        return (
            <Box style={styles.dotsContainer}>
                <Spinner />
            </Box>
        )
    }

    if (isCreating) {
        return (
            <VerticalStack style={styles.listContainer}>
                <Input
                    value={listName}
                    onChange={(value) => setListName(value)}
                    placeholder={COPY.FORM_LABELS.NAME}
                />
                <Button
                    isLoading={isLoading}
                    disabled={listName.length < 1}
                    style={styles.button}
                    onClick={() =>
                        createWishlist({
                            data: {
                                name: listName,
                                user: user.id,
                            },
                        })
                    }
                >
                    <Box style={styles.buttonText}>{COPY.CREATE}</Box>
                </Button>
            </VerticalStack>
        )
    }

    return (
        <Box style={styles.listContainer}>
            <SaveModalList
                listingId={listingId}
                wishlists={wishlists}
                onClose={onClose}
            />
            <Button style={styles.button} onClick={() => setIsCreating(true)}>
                <Box style={styles.buttonText}>{COPY.CREATE_WISHLIST}</Box>
            </Button>
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        button: {
            marginTop: 5,
            width: "100%",
            borderRadius: 8,
            height: "4rem",
        },
        buttonText: {
            width: "100%",
            fontWeight: "bold",
            textAlign: "center",
        },
        dotsContainer: {
            paddingBottom: "48px",
            minWidth: { sm: "400px" },
        },
        listContainer: {
            alignContent: "center",
            gap: 3,
        },
    })
}
